export const submissionStatusTextEnum = {
    none: "None",
    finalScored: "FinalScored",
    hasSubmission: "HasSubmission"
}
export const submissionStatusEnum = {
    none: 0,
    finalScored: 1,
    hasSubmission: 2
}